import {API_ADMIN_URL, ANALYSER_URL} from "../../config/constants";
import { postRequest } from '../API'
/*********************************************************
* Function Name : list
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 24-12-2024 
*********************************************************/
export const list = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}hourly-games/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : getDrawSlots
* Description   : Get hourly draw slots for a date
*********************************************************/
export const getDrawSlots = async (date) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}hourly-games/draw-slots`,
            postData : { date }
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return { status : true, result : res?.data?.response?.result || {} };
        }
        return {
            status : false,
            message : res?.response?.data?.statusMessage || "Unable to fetch hourly slots.",
        };
    } catch (error) {
        console.log(error);
        return {status : false, message:"Under Maintenance, Please try after some time."};
    }
};//End of Function

/*********************************************************
* Function Name : getResultData
* Description   : Get hourly result data from backend
*********************************************************/
export const getResultData = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}hourly-games/result-data`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result || []};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : getCouponDetails
* Description   : Get coupon details from backend
*********************************************************/
export const getCouponDetails = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}hourly-games/coupon-details`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result || []};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : publishWinner
* Description   : Publish the winners
*********************************************************/
export const publishWinner = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}hourly-games/create-winners`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result || []};
        } else{
            const responseData = res?.response?.data || res?.data || {};
            return {
                status : false,
                message: responseData?.statusMessage,
                errorCode: responseData?.statusCode
            };
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : listWinningCouponCache
* Description   : Get current cached winning coupons (23hr window)
*********************************************************/
export const listWinningCouponCache = async (options = {}) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}hourly-games/winning-coupon-cache/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {
                status : true,
                result : res?.data?.response?.result || [],
                count : res?.data?.response?.count || 0
            };
        }
        return {
            status : false,
            message : res?.response?.data?.statusMessage || "Unable to fetch winning coupon cache."
        };
    } catch (error) {
        console.log(error);
        return {status : false, message:"Under Maintenance, Please try after some time."};
    }
};//End of Function